'use strict';

module.exports = [function () {
    return {
        replace: true,
        scope: true, 
        template: require('./formButton.html')
    };
}];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/formButton.js
// module id = 380
// module chunks = 0